import Switch from "@material-ui/core/Switch"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useHistory, Link } from "react-router-dom"
import { useTheme } from "@material-ui/core/styles"
import { ROUTES } from "../utils"
import { setMode } from "../actions/themeActions"

const Header = ({ section, page, clientCase = true }) => {
	const [t, i18n] = useTranslation("global")
	const history = useHistory()
	const dispatch = useDispatch()
	const theme = useTheme()
	const mode = useSelector((state) => state.theme.mode)
	const [darkMode, setDarkMode] = useState(mode === "light" ? false : true)

	const handleModeChange = (e) => {
		setDarkMode(e.target.checked)
		const selectedMode = e.target.checked ? "dark" : "light"
		localStorage.setItem("mode", selectedMode)
		dispatch(setMode(selectedMode))
	}

	return (
		<div className="d-flex justify-content-between py-1 text-dark px-3 border-bottom">
			<span className="text-dark mb-0">
				<Link to={ROUTES.SEARCH}>
					<i className="bi bi-house-door-fill"></i>
				</Link>
				{clientCase && (
					<>
						<span className="mx-2">Client case {window._env_.REACT_APP_CLIENT_ID}</span>
						<i className="bi bi-chevron-right"></i>
						<span className="mx-2">{section}</span>
					</>
				)}
				<i className="bi bi-chevron-right"></i>
				<span className="mx-2">{page}</span>
			</span>
			<div>
				<span id="submitReload">
					<a
						onClick={(e) => {
							e.preventDefault()
							window.location.reload(false)
						}}
					>
						{t("header.reload_page")}
					</a>
				</span>
				<span id="submitFeedback">
					<a
						href="https://forms.office.com/Pages/ResponsePage.aspx?id=_1Njm0qVaUetokSw4-NGyUGAlpldGS5BqEN8H9zIig1UMEQzU1E5R0I2MkxSNTc3N0JCN0Y2TFZNUC4u"
						target="_blank"
						rel="noreferrer"
					>
						{t("header.submit_feedback")}
					</a>
				</span>
				{/* Commenting this for now. we will enable this when we need dark mode */}
				{/* <span>
            <Switch
              checked={darkMode}
              onChange={handleModeChange}
              color="primary"
              name="checkedB"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </span> */}
				{/* <span>|</span>
          {(history.location.pathname === ROUTES.BIFROST) ? 
            (<>
              <span>
                <a id='bifrost' onClick={(e)=>{
                    e.preventDefault()
                    history.push(ROUTES.SEARCH)
                  }}>
                  Home
                </a>
              </span>
            </>) : 
            (<>
              <span>
                <a id='bifrost' onClick={(e)=>{
                  e.preventDefault()
                  history.push(ROUTES.BIFROST)
                }}>
                  Bifrost
                </a>
              </span>
            </>)
          } */}
			</div>
			{window._env_.REACT_APP_ALLOW_MULTI_LANGUAGE === true ? (
				<div id="btnTranslation">
					<button className="btn btn-sm btn-primary btnTranslation" onClick={() => i18n.changeLanguage("es")}>
						ES
					</button>
					<button className="btn btn-sm btn-primary btnTranslation" onClick={() => i18n.changeLanguage("en")}>
						EN
					</button>
				</div>
			) : null}
		</div>
	)
}

export default Header
